
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideMomentDateAdapter } from '@angular/material-moment-adapter';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { AppRoutingModule } from './app/app-routing.module';
import { AppComponent } from './app/app.component';
import { AuthInterceptor } from './app/services/auth.interceptor';
import { ContentTypeCharsetInterceptor } from './app/services/content-type-charset.interceptor';
import { HttpErrorInterceptor } from './app/services/http-errors.interceptor';
import { environment } from './environments/environment';

void bootstrapApplication( AppComponent, {
  providers: [
    provideZoneChangeDetection(), importProvidersFrom( BrowserModule, AppRoutingModule, FormsModule, ReactiveFormsModule ),
    provideHttpClient( withInterceptorsFromDi() ),
    ...provideTranslateService( { lang: 'en' } ),
    ...provideTranslateHttpLoader( { prefix: './assets/i18n/', suffix: '.json?' + environment.buildNumber } ),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ContentTypeCharsetInterceptor,
      multi: true
    },
    provideAnimations(),
    provideMomentDateAdapter()
  ]
} ).catch( ( err: unknown ) => console.error( err ) );
